import { weekGridClasses } from '@utils/styles'

export function SummaryRow(props: {
  children?: React.ReactNode
  testId?: string
  weekStartsOn: 'sunday' | 'monday'
}) {
  return (
    <div
      className={weekGridClasses(props.weekStartsOn)}
      data-testid={props.testId}
    >
      {props.children}
    </div>
  )
}
